import React from "react";
import WarningRouter from './Warning/Router';
export { getFields, getReplyFields } from './Warning/Router';

export default function EarlyWarningSupplierRouter(props){
    return <WarningRouter {...props} mode='CLIENT' />;
}